/**
 * Trava de "em andamento" por chave (TMS-7223 — idempotência do cancelamento).
 *
 * Duplo clique em "Cancelar a expedição" disparava dois `POST /api/expedicao/cancelar`: o
 * modal só desabilitava os botões nos passos que passam por `executarPassoDoBloqueio`, e o
 * botão do último passo chama o cancelamento direto. A trava vale para qualquer chamador:
 * a segunda tentativa, enquanto a primeira está em voo, é ignorada.
 *
 * Módulo puro (estado em closure, sem Vue) para ser testado sem `vue-jest`. A chave é
 * normalizada para texto, então `9275151` e `"9275151"` são a mesma carga.
 *
 * Sem `?.` nem `??`: o toolchain do isend-frontend não os compila.
 */
export function criarTrava() {
  const emCurso = {};

  return {
    /** @returns {boolean} `true` se esta chamada ganhou a vez; `false` se já há uma em voo */
    tentar(chave) {
      const k = String(chave);

      if (emCurso[k] === true) {
        return false;
      }

      emCurso[k] = true;

      return true;
    },

    liberar(chave) {
      delete emCurso[String(chave)];
    },

    estaEmCurso(chave) {
      return emCurso[String(chave)] === true;
    },
  };
}
